export default __webpack_public_path__ + "static/media/ervaren-monteurs.8d8bcbc5.jpg";